import ArrowDownGlyph from '../../../../icons/ArrowDownGlyph';
import ArrowUpGlyph from '../../../../icons/ArrowUpGlyph';
import ArrowRightGlyph from '../../../../icons/ArrowRightGlyph';

import { type IIconsProps } from '../../../Icon';

const megaMenuClasses = '';

const megaMenuButtonClasses = '';
const megaMenuButtonTextClasses = '';

const megaMenuItemClasses = '';
const megaMenuItemNameClasses = '';

/**
 * MobileFlyoutMegaMenu Icon Props
 */

const megaMenuIconProps: IIconsProps = {
  bg: false,
  size: 'Glyph',
  options: {
    viewBox: '0 0 8 8',
    width: '6',
    height: '4',
    className: 'fill-neutrals-800',
  },
};

/**
 * MobileFlyoutMegaMenu Theme
 */

const mobileFlyoutMegaMenuBlogTheme = {
  megaMenuButtonClasses,
  megaMenuButtonTextClasses,
  megaMenuClasses,
  megaMenuItemClasses,
  megaMenuItemNameClasses,

  megaMenuIconProps,
  ExpandMoreIcon: ArrowDownGlyph,
  ExpandLessIcon: ArrowUpGlyph,
  ChevronRightIcon: ArrowRightGlyph,
};

/**
 * Exports
 */

export default mobileFlyoutMegaMenuBlogTheme;
